import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeft, ExternalLink, CreditCard } from 'react-feather';
import { formatCurrencyWithConversion } from '../utils/currency';
import './DepositCheckout.css';

export default function DepositCheckout() {
  const location = useLocation();
  const navigate = useNavigate();
  const checkout = location.state;

  useEffect(() => {
    if (!checkout?.paymentUrl) {
      navigate('/dashboard/deposit', { replace: true });
    }
  }, [checkout, navigate]);

  if (!checkout?.paymentUrl) {
    return null;
  }

  const openProviderCheckout = () => {
    window.location.href = checkout.paymentUrl;
  };

  return (
    <div style={{ maxWidth: 640 }}>
      <div className="deposit-checkout-top-actions">
        <button
          className="btn btn-secondary deposit-checkout-back-btn"
          type="button"
          onClick={() => navigate('/dashboard/deposit')}
        >
          <ArrowLeft size={16} /> Back to Deposit
        </button>
      </div>

      <h1 className="page-title">Checkout</h1>
      <p className="page-subtitle">Review your deposit, then continue to the payment provider.</p>

      <div className="card" style={{ marginBottom: 20 }}>
        <div style={{ display: 'flex', gap: 12, alignItems: 'center', marginBottom: 18 }}>
          <div style={{
            width: 46,
            height: 46,
            borderRadius: 14,
            background: 'var(--accent-glow)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'var(--accent)',
          }}>
            <CreditCard size={20} />
          </div>
          <div>
            <div style={{ fontWeight: 800, fontSize: 18, fontFamily: 'Syne, sans-serif' }}>{checkout.gateway} Checkout</div>
            <div style={{ color: 'var(--text-muted)', fontSize: 14 }}>You can return to deposits before opening the payment provider.</div>
          </div>
        </div>

        <div style={{
          padding: '16px 18px',
          border: '1px solid var(--border)',
          borderRadius: 'var(--radius)',
          background: 'var(--bg-elevated)',
          marginBottom: 18,
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', gap: 16, marginBottom: 8 }}>
            <span style={{ color: 'var(--text-muted)' }}>Deposit amount</span>
            <strong>{checkout.displayAmount}</strong>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', gap: 16 }}>
            <span style={{ color: 'var(--text-muted)' }}>Estimated credit</span>
            <strong style={{ color: 'var(--green-500)' }}>
              {formatCurrencyWithConversion(checkout.creditedUsd || 0, 'USD', 2)}
            </strong>
          </div>
        </div>

        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
          <button className="btn btn-primary deposit-checkout-pay-btn" type="button" onClick={openProviderCheckout}>
            <ExternalLink size={16} /> Continue to Payment
          </button>
        </div>
      </div>

      <div className="card" style={{ color: 'var(--text-muted)', fontSize: 14, lineHeight: 1.7 }}>
        <div>After your payment finishes, the provider will send you back to the deposit page automatically.</div>
        <div>If the payment is still pending when you return, your deposit history will update as soon as the gateway confirms it.</div>
      </div>
    </div>
  );
}
